<template>
  <div class="edu-homepage">
    <el-carousel height="400px" v-loading="loadingCar" >
      <el-carousel-item v-for="(item, index) in carouselList" :key="index">
        <a @click="getDetail(item)"><img :src="item.path" width="100%" height="400px" style="object-fit:cover;cursor: pointer"></a>
      </el-carousel-item>
    </el-carousel>
    <card :cardType="'3'" :itemList="teacherList" :loading="loadingTeacher"></card>
    <card :cardType="'0'" :itemList="trainList" :loading="loadingTrain"></card>
    <card :cardType="'1'" :itemList="educationList" :loading="loadingEdu"></card>

    <!--<card :cardType="'2'" :itemList="infoList" :loading="loadingInfo"></card>-->

  </div>
</template>

<script>
  import { pageListTeacher } from '@/api/teacher'
  const card = () => import('./Card')
  export default {
    name: "Page",
    data() {
      return {
        loadingCar:false,
        loadingTrain:false,
        loadingEdu:false,
        loadingInfo:false,
        loadingTeacher: false,
        carouselList: [],
        trainList: [],
        educationList: [],
        infoList: [],

        teacherList: [],  // 讲师列表
      };
    },
    // computed: {
    //   screenWidth: function(){
    //     return this.$store.state.screenWidth;
    //   }
    // },
    methods: {
      getDetail(item){
        if (item.redirectPath) {
          window.open(item.redirectPath,'_blank');
        }else {
          let routerMyCard;
          switch (item.type) {
            case "O":
              routerMyCard = this.$router.resolve('/home/trainDetail/'+item.typeId);
              break;
            case "C":
              routerMyCard = this.$router.resolve('/home/eduDetail/'+item.typeId);
              break;
            case "I":
              routerMyCard = this.$router.resolve({path:'/home/article/',query:{id: item.typeId}});
              break;
            case "H":
              routerMyCard = this.$router.resolve({path:'/home/help/',query:{id: item.typeId}});
              break;
          }
          window.open(routerMyCard.href,'_blank')
        }
      },
      async getCarouselList(){
        this.loadingCar = true;
        const {content} = await this.$http.get('/business/web/carousel/homeList')
        this.carouselList = content;
        this.loadingCar = false;
      },
      async getTrainList(){
        this.loadingTrain = true;
        const param = {courseType: "O"}
        const {content} = await this.$http.get('/business/web/course/homeList',{params:param})
        this.trainList = content;
        this.loadingTrain = false;
      },
      async getEducationList(){
        this.loadingEdu = true;
        const param = {courseType: "C"}
        const {content} = await this.$http.get('/business/web/course/homeList',{params:param})
        this.educationList = content;
        this.loadingEdu = false;
      },
      async getTeacherList() {
        this.loadingTeacher = true;
        let queryParams = {
          page: 1,
          size: 10,
          name: undefined,
          position: undefined,
        }
        const { content } = await pageListTeacher(queryParams)
        this.teacherList = content.records
        this.loadingTeacher = false
      },
      async getInfoList(){
        this.loadingInfo = true;
        const {content} = await this.$http.get('/business/web/information/homeList')
        this.infoList = content;
        this.loadingInfo = false;
      },
      // getStyle(){
      //   return this.screenWidth>1200? String(this.screenWidth/4)+'px':'300px'
      // }
    },
    components:{
      card
    },
    mounted() {
      this.getCarouselList();
      this.getTrainList();
      this.getEducationList();
      this.getInfoList();
      this.getTeacherList()
    }
  }
</script>

<style scoped>
  .edu-homepage{
    /*min-width: 1200px;*/
    width: 1200px;
    margin: 35px auto 70px auto;
    /*margin-bottom: 70px;*/
  }
  .el-carousel__item {
    background-color: #99a9bf;
  }
  >>> .el-loading-mask{
    z-index: 900 !important;
  }
</style>
